export default "__VITE_ASSET__go3kt$Pk__"